module.exports = __webpack_public_path__ + "img/pipes_with_relay.349961b4.svg";